import { defineFcm } from '../shared/factory';

export const FCM_DISABLE_GEOLOCATION_GUEST_SIGN_FORM = defineFcm('disable_geolocation_guest_sign_form')
	.asBoolean()
	.withDefault(false)
	.toConfig();
